import { createContext, useContext } from 'react'

export type ListAction = {
  id: string
  label: string
  icon?: string

  primary?: boolean

  disabled?: boolean
  loading?: boolean

  iconOnly?: boolean
}
export type ListSelection = { actions: ListAction[]; onRun: (id: string) => void }

const ListActionsSink = createContext<((sel: ListSelection | null) => void) | null>(null)
export const ListActionsProvider = ListActionsSink.Provider

export function useListActionsSink() {
  return useContext(ListActionsSink)
}
